module.exports = __webpack_public_path__ + "static/img/papalii-joash.241ab22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/papalii-joash.jpg
// module id = 61Os
// module chunks = 0